import { render, staticRenderFns } from "./ANotificacion.vue?vue&type=template&id=211414ce&scoped=true"
import script from "./ANotificacion.vue?vue&type=script&lang=js"
export * from "./ANotificacion.vue?vue&type=script&lang=js"
import style0 from "./ANotificacion.vue?vue&type=style&index=0&id=211414ce&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211414ce",
  null
  
)

export default component.exports